import Vue from 'vue'
import axios from 'axios'
// import {stringify} from 'qs'
let sign;
axios.defaults.withCredentials = true;

let pending = {}; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (url) => {
  if(pending[url]) { //当当前请求在数组中存在时执行函数体
      pending[url]("cancel"); //执行取消操作
      delete pending[url];
  }
}  

axios.interceptors.request.use(
  config => {
    // if(config.url.indexOf("ExternalInterface") === -1){
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    sign = window.localStorage.getItem("sign");
    if(sign){
      config.headers['sign'] = sign;
    }
    config.headers['Content-Type']="application/json";
    config.data = JSON.stringify(config.data);
    config.cancelToken = new cancelToken((c)=>{
      pending[config.url] = c
    })
    return config;
  },
  error => {
    console.log("requestERR", error)
  }
);

// response 拦截器,数据返回后进行一些处理
axios.interceptors.response.use(
  response => {
    // console.log("OK" ,response.config.url);
    if(response.config.url !== "/dict/GetListByType"){
      removePending(response.config.url);
    }
    if(response.data.code === 401 || response.status === 401){
      window.localStorage.removeItem("sign");
      window.location.href = "/#/login"
    }
    if(!response.data.success){
      Vue.prototype.$Message.error(response.data.message?response.data.message:"请求错误");
    }
    return response;
  },
  error => {
    if(error.message === "cancel"){
      return
    }
    Vue.prototype.$Message.destroy();
    Vue.prototype.$Message.error(error.message);
  }
);

let EV = {
  method: "POST",
  host: "/"
};

export default {
  install(Vue) {
    Vue.prototype.api = (src, params, method, p) => {
      let url = p?src:EV.host + src;
      if(method === "get" || method === "delete"){
        return axios({
          url: url,
          method: method,
          params: params
        })
      }else{
        return axios({
          url: url,
          method: method,
          data: params
        })
      }
    };
    Vue.prototype.apiCancel = (src) => {
      let url = "/"+src;
      removePending(url);
    };
  }
}